import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    voucherListFilters:{
        searchBy:1,
        searchSTKTVVouFromDate:"",
        searchSTKTVVouToDate:"",
        searchSTKTVVouNo:"",
        searchSTKTVStatusIds:"",
        searchSTKTVReqFromDate:"",
        searchSTKTVReqToDate:"",
        searchSTKTVReqNo:"",
        searchSTKTVRequestedFromStoreIds:"",
    },
    voucherListData: {
        isLoading: false,
        dataLoaded: false,
        transferVoucherError: "",
    },
    editVoucherData: {
        voucherMode: 3, // 1 - Against Transfer Request, 2 - Against Store, 3 - Manual Transfer ( Default )
        isEditing: false,
        isLoading: false,
        isDataLoaded: true,
        voucherData: null,
        selectedTransferVoucherId:null,
        isLoadingFailed: false,
        failedMessage: null
    },
    showVoucherListTable: false,
    loadtransferVoucherList: false,
    showTransferVoucherForm: false,
    showTransferVoucherPreview:false,
    transferVoucherIdForPreview:null,
    transferVoucherStatusForPreview:0,
    showTransferVoucherStatusLogPreview:false,
    transferVoucherRowForStatusLogPreview:null,
};

const outwardInventoryTransferSlice = createSlice({
    name: "outwardInventoryTransfer",
    initialState,
    reducers: {
        outwardInventoryTransferVoucherListFiltersUpdates: (state, { payload }) => {
            if (payload?.searchBy ||
                payload?.searchSTKTVVouFromDate || 
                payload?.searchSTKTVVouToDate || 
                payload?.searchSTKTVVouNo || 
                payload?.searchSTKTVStatusIds || 
                payload?.searchSTKTVReqFromDate ||
                payload?.searchSTKTVReqToDate ||
                payload?.searchSTKTVReqNo || 
                payload?.searchSTKTVRequestedFromStoreIds
            ){
                let resetFieldValues = {};
                if(payload?.searchBy){
                    if(payload?.searchBy === 1){
                        resetFieldValues = {
                            searchSTKTVReqFromDate:"",
                            searchSTKTVReqToDate:"",
                            searchSTKTVReqNo:"",
                            searchSTKTVRequestedFromStoreIds:"",
                        }
                    }else{
                        resetFieldValues = {
                            searchSTKTVVouFromDate:"",
                            searchSTKTVVouToDate:"",
                            searchSTKTVVouNo:"",
                            searchSTKTVStatusIds:"",
                        }
                    }
                }
                state.voucherListFilters = {...state.voucherListFilters, ...payload, ...resetFieldValues}
            }
            state.showVoucherListTable = false;
        },
        outwardInventoryTransferVoucherListFiltersReset: (state) => {
            state.voucherListFilters = {...initialState.voucherListFilters};
        },
        outwardInventoryTransferVoucherSetLoadList: (state) => {
            state.showVoucherListTable = true;
            state.loadtransferVoucherList = true;
        },
        outwardInventoryTransferVoucherListLoadingPending: (state) => {
            state.voucherListData.isLoading = true;
            state.voucherListData.dataLoaded = false;
        },
        outwardInventoryTransferVoucherListLoadingSuccess: (state, { payload }) => {
            state.voucherListData.isLoading = false;
            state.voucherListData.transferRequestError = "";
            state.voucherListData.dataLoaded = true;
            state.loadtransferVoucherList = false;
        },
        outwardInventoryTransferVoucherListLoadingFailed: (state, { payload }) => {
            state.voucherListData.isLoading = false;
            state.voucherListData.transferRequestError = payload;
            state.voucherListData.dataLoaded = true;
            state.loadtransferVoucherList = false;
        },
        setOutwardInventoryTransferVoucherFormMode:(state,{payload}) => {
            state.editVoucherData.voucherMode = payload;
        },
        toggleOutwardInventoryVoucherForm: (state, {payload}) => {
            state.showTransferVoucherForm = payload;
        },

        // Edit Receive Voucher Reducers
        outwardInventoryVoucherSetFormEdit: (state,{payload}) => {
            state.editVoucherData.isEditing = true;
            state.editVoucherData.selectedTransferVoucherId = payload;
        },
        outwardInventoryTransferVoucherFormDataLoadingPending: (state) => {
            state.editVoucherData.isLoading = true;
            state.editVoucherData.isDataLoaded = false;
        },
        outwardInventoryTransferVoucherFormDataLoadingSuccess: (state, { payload }) => {
            state.editVoucherData.isLoading = false;
            state.editVoucherData.voucherData = payload;
            state.editVoucherData.failedMessage = "";
            state.editVoucherData.isDataLoaded = true;
            state.editVoucherData.isLoadingFailed = false;
        },
        outwardInventoryTransferVoucherFormDataLoadingFailed: (state, { payload }) => {
            state.editVoucherData.isLoading = false;
            state.editVoucherData.voucherData = null;
            state.editVoucherData.failedMessage = payload;
            state.editVoucherData.isDataLoaded = true;
            state.editVoucherData.isLoadingFailed = true;
        },
        outwardInventoryTransferVoucherFormDataReset: (state, { payload }) => {
            state.editVoucherData.voucherMode = 3;
            state.editVoucherData.isEditing = false;
            state.editVoucherData.isLoading = false;
            state.editVoucherData.voucherData = null;
            state.editVoucherData.failedMessage = null;
            state.editVoucherData.isDataLoaded = false;
            state.editVoucherData.isLoadingFailed = false;
            state.editVoucherData.selectedTransferVoucherId = null;
        },
        outwardInventoryTransferVoucherPreviewShow: (state,{payload}) => {
            state.transferVoucherIdForPreview = payload.transferVoucherId;
            state.transferVoucherStatusForPreview = payload.voucherStatus
        },
        toggleOutwardInventoryVoucherPreview: (state, {payload}) => {
            state.showTransferVoucherPreview = payload;
        },
        toggleOutwardInventoryVoucherStatusLogPreview: (state, {payload}) => {
            state.showTransferVoucherStatusLogPreview = payload;
        },
        outwardInventoryTransferVoucherStatusLogPreviewShow: (state,{payload}) => {
            state.transferVoucherRowForStatusLogPreview = payload;
        },
    }
});


const { reducer, actions } = outwardInventoryTransferSlice;

export const {
    outwardInventoryTransferVoucherListFiltersUpdates,
    outwardInventoryTransferVoucherListFiltersReset,
    outwardInventoryTransferVoucherSetLoadList,
    outwardInventoryTransferVoucherListLoadingPending,
    outwardInventoryTransferVoucherListLoadingSuccess,
    outwardInventoryTransferVoucherListLoadingFailed,
    setOutwardInventoryTransferVoucherFormMode,
    toggleOutwardInventoryVoucherForm,
    outwardInventoryVoucherSetFormEdit,
    outwardInventoryTransferVoucherFormDataLoadingPending,
    outwardInventoryTransferVoucherFormDataLoadingSuccess,
    outwardInventoryTransferVoucherFormDataLoadingFailed,
    outwardInventoryTransferVoucherFormDataReset,
    outwardInventoryTransferVoucherPreviewShow,
    toggleOutwardInventoryVoucherPreview,
    toggleOutwardInventoryVoucherStatusLogPreview,
    outwardInventoryTransferVoucherStatusLogPreviewShow
  } = actions;

  export default reducer;